var render, staticRenderFns
import script from "./Toaster.vue?vue&type=script&lang=js&"
export * from "./Toaster.vue?vue&type=script&lang=js&"
import style0 from "./Toaster.vue?vue&type=style&index=0&id=be5470f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports